export default __webpack_public_path__ + "static/phone-image-5f69bb88efd229763ffbc5f3bdbd9fb4.png";